export function transformToLargeDir(src: string) {
  if (!src) {
    return ''; // Return an empty string or handle the case as needed
  }
  return src.replace('/main/', '/large/');
}
